import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const ContactProspectsModelSchema = z
  .object({
    id: z.string(),
    prospect_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    relationship_category_id: z.string().nullish(),
    title: z.string().nullish(),
    current: z.boolean().nullish(),
    from: z.string().nullish(),
    to: z.string().nullish(),
    trashed: z.boolean().nullish()
  })
  .strict()

export const ContactProspectsModelFields = makeFieldKeys(ContactProspectsModelSchema)

export type ContactProspectsModel = z.infer<typeof ContactProspectsModelSchema>

function validateContactProspectsModel(data: unknown): ContactProspectsModel {
  try {
    return validateWithZodSchema(ContactProspectsModelSchema, data, 'contact prospects model')
  } catch (error) {
    throw new Error(`Contact prospects model validation failed: ${error}`)
  }
}
